import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
     fill="#BDDEFF"
      fillOpacity={1}
      d="M7.73 0c1.643 0 2.934 0 3.942.136 1.032.139 1.851.428 2.495 1.072.644.644.933 1.463 1.072 2.495.136 1.008.136 2.299.136 3.942v.085c0 1.643 0 2.934-.136 3.942-.139 1.032-.428 1.851-1.072 2.495-.644.644-1.463.933-2.495 1.072-1.008.136-2.299.136-3.942.136h-.085c-1.643 0-2.934 0-3.942-.136-1.032-.139-1.851-.428-2.495-1.072-.644-.644-.933-1.463-1.072-2.495C0 10.664 0 9.373 0 7.73v-.085C0 6.002 0 4.71.136 3.703c.139-1.032.428-1.851 1.072-2.495C1.852.564 2.671.275 3.703.136 4.711 0 6.002 0 7.645 0h.085ZM3.937 7.875a.563.563 0 0 0-.562.563v3a.562.562 0 1 0 1.125 0v-3a.563.563 0 0 0-.563-.563Zm3.75-4.5a.563.563 0 0 0-.562.563v7.5a.562.562 0 1 0 1.125 0v-7.5a.563.563 0 0 0-.563-.563Zm3.75 3a.562.562 0 0 0-.562.563v4.5a.562.562 0 1 0 1.125 0v-4.5a.562.562 0 0 0-.563-.563Z"
    />
  </svg>
)
export default SvgComponent
